import React from 'react'
import styled from 'styled-components'
import { brand, gray } from 'sutra/tokens/colors'

export interface StatProps {
  value: string
  label: string
  className?: string
}

const StatRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const StatValue = styled.div`
  font-family: 'Poppins', system-ui, sans-serif;
  font-weight: 600;
  font-size: 60px;
  line-height: 1;
  letter-spacing: -0.025em;
  color: ${brand.stillNight[800]};
`

const StatLabel = styled.div`
  font-family: 'Poppins', system-ui, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: ${gray[600]};
`

export const Stat = ({
  value,
  label,
  className,
}: StatProps): React.ReactElement => (
  <StatRoot className={className}>
    <StatValue>{value}</StatValue>
    <StatLabel>{label}</StatLabel>
  </StatRoot>
)

Stat.displayName = 'Stat'
